<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-10">
            <h4 class="fw-bold">Operating lease commitments - {{commonService.headerName}}</h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-2 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;" tabindex="-1" (click)="TotalBack()">
              Close Accounts
            </button>
          </div>
        </div>
      </div>
      <hr />
      <form [formGroup]="commitmentform" (ngSubmit)="save()">
        <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12 ">
          <div class="row">
            <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12">
              <!--<h5 class="fw-bolder font-size-16">Operating lease commitments</h5>-->
              <div class="">
                <p class="mt-1">Please enter notes on operating lease commitments.</p>
                <p>If you do not have any notes to make, please return to the notes menu and de-select this section.</p>
              </div>
              <div class="col-xl-11 col-lg-10 col-md-12 col-sm-12 col-12 mt-2 p-0 p-lg-2">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                          <label class="m-t-5 font-weight-600"></label>
                        </div>
                        <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                          <div class="row">
                            <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                              <div class="col-lg-12 text-center">
                                <h6 class="mb-0 fw-bolder">{{commonService.StartYear}}</h6>
                                <label>({{commonService.CAPeriodFrom}} to {{commonService.CAPeriodTo}})</label>
                              </div>
                            </div>
                            <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                              <div class="col-lg-12 text-center">
                                <h6 class="mb-0 fw-bolder">{{commonService.LastYear}}</h6>
                                <label>({{commonService.StartdateLastAP}} to {{commonService.LYAccountingPeriod}})</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 ps-0 ps-lg-5">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                          <label class="m-t-5 font-weight-600">Within one year</label>
                        </div>
                        <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                          <div class="row">
                            <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                              <div class="input-group mb-3">
                                <div class="input-group-text">
                                  <span class=" theme-color font-weight-600">£</span>
                                </div>
                                <input type="text" class="form-control text-end AccountNumber" appNumberdirective (change)="Commitmentscal()" formControlName="OperatingLeasesExpiringWithinOneYear" maxlength="11" />
                              </div>
                            </div>
                            <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                              <div class="input-group mb-3">
                                <div class="input-group-text">
                                  <span class=" theme-color font-weight-600">£</span>
                                </div>
                                <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective (change)="Commitmentlastyearcal() " formControlName="OperatingLeasesExpiringWithinOneYear_LY" maxlength="11" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                     </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                              <label class="m-t-5 font-weight-600">Between one and five years</label>
                            </div>
                            <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                              <div class="row">
                                <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                                  <div class="input-group mb-3">
                                    <div class="input-group-text">
                                      <span class=" theme-color font-weight-600">£</span>
                                    </div>
                                    <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective (change)="Commitmentscal()" formControlName="OperatingLeasesExpiringBetweenTwoFiveYears" maxlength="11" />
                                  </div>
                                </div>
                                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6"  *ngIf="commonService.showControl==true">
                                  <div class="input-group mb-3">
                                    <div class="input-group-text">
                                      <span class=" theme-color font-weight-600">£</span>
                                    </div>
                                    <input type="text" class="form-control text-end AccountNumber" appNumberdirective (change)="Commitmentlastyearcal()" formControlName="OperatingLeasesExpiringBetweenTwoFiveYears_LY" maxlength="11" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            </div>
                          </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                              <label class="m-t-5 font-weight-600">Over five years</label>
                            </div>
                            <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                              <div class="row">
                                <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                                  <div class="input-group mb-3">
                                    <div class="input-group-text">
                                      <span class=" theme-color font-weight-600">£</span>
                                    </div>
                                    <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective (change)="Commitmentscal()" formControlName="OperatingLeasesExpiringAfterFiveYears" maxlength="11" />
                                  </div>
                                </div>
                                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                                  <div class="input-group mb-3">
                                    <div class="input-group-text">
                                      <span class=" theme-color font-weight-600">£</span>
                                    </div>
                                    <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective (change)="Commitmentlastyearcal() " formControlName="OperatingLeasesExpiringAfterFiveYears_LY" maxlength="11" />
                                  </div>
                                </div>
                              </div>
                            </div>
                           </div>
                          </div>
                            <div class="form-group">
                              <div class="row">
                                <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                                  <label class="m-t-5 font-weight-600">Total</label>
                                </div>
                                <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                                  <div class="row">
                                    <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                                      <div class="input-group mb-3">
                                        <div class="input-group-text">
                                          <span class=" theme-color font-weight-600">£</span>
                                        </div>
                                        <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective formControlName="OperatingLeases" maxlength="11" value="0" disabled />
                                      </div>
                                    </div>
                                    <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                                      <div class="input-group mb-3">
                                        <div class="input-group-text">
                                          <span class=" theme-color font-weight-600">£</span>
                                        </div>
                                        <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective formControlName="OperatingLeases_LY" maxlength="11" value="0" disabled />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                </div>
                <div class="row mt-4">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
                    <label>Please enter any additional information in the field below.</label>
                    <textarea class="form-control allowSpecialChars" [appTooltip]="showBubbledata" appNumberdirective formControlName="AndicaOpreatingLease" rows="5" maxlength="4000"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-1 text-end mt-4 pe-0">
              <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="back()">Back</button>
              <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="save()">Next</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
